module.exports = __webpack_public_path__ + "img/img_14.a1d950a2.png";